import { PageBlock } from '@design-system/page-block';
import { Typography } from '@design-system/typography';
import React, { forwardRef } from 'react';

import { LdsProps } from './models';

const LdsBlock = forwardRef<HTMLDivElement, LdsProps>(
  ({ ldsContent, pageBlockUI }, ref) => (
    <PageBlock {...pageBlockUI} className="lds-block" ref={ref}>
      <Typography content={ldsContent} variant="rte" />
    </PageBlock>
  )
);

export default LdsBlock;
